// Short flavor-text descriptions shown in the recruit modal. Indexed by
// unit id (see ArmyScreen UnitPngById for the full list). Written for new
// players — plain words, what the unit does and where it fits in a fight.
export const UnitDescriptions: Record<string, string> = {
  // Fire
  "fire-guardian":
    "Огненный страж в раскалённой броне. Идёт в первой линии — врагу нужно через него пробиться.",
  "fire-archer":
    "Лучник с зажжёнными стрелами. Прошивает броню за счёт горения, эффективен против тяжёлых противников.",
  "fire-pyromancer":
    "Маг огня. Бьёт по площадям — самые сильные потери врагу наносит, когда у него много пехоты.",
  "fire-phoenix":
    "Феникс — сигнатурное существо стихии огня. Возрождается после смерти и ломает ход боя.",

  // Water
  "water-golem":
    "Ледяной голем. Толстая броня и большой запас здоровья — принимает атаки на себя, пока бьют союзники.",
  "water-archer":
    "Лучник с ледяными стрелами. Замедляет цель и стреляет точно — хорош против быстрой пехоты.",
  "water-cryomancer":
    "Маг льда. Замораживает группы противника, снижая их урон по твоим войскам.",
  "water-mermaid":
    "Русалка — сигнатурное существо стихии воды. Лечит твои отряды прямо в бою.",

  // Air
  "air-harpy":
    "Гарпия. Лёгкая и быстрая, бьёт первой за счёт инициативы — пока враг разворачивается, она уже наносит урон.",
  "air-archer":
    "Лучник на крыльях. Стреляет с высоты — попадает чаще, и его сложнее достать в ближнем бою.",
  "air-aero":
    "Маг ветра. Сшибает противника вихрем, разрушает плотный строй и облегчает работу твоей пехоте.",
  "air-griffin":
    "Грифон — сигнатурное существо стихии воздуха. Налетает на тыл — добирается до магов и стрелков противника.",

  // Earth
  "earth-golem":
    "Каменный голем. Самая прочная броня среди пехоты — врагу понадобится много ударов, чтобы его свалить.",
  "earth-quaker":
    "Стрелок с пращой и камнями. Бьёт тяжело, может достать через всю карту, но стреляет медленнее обычных лучников.",
  "earth-geo":
    "Маг земли. Поднимает каменные шипы из-под ног противника — особенно эффективен против бронированных.",
  "earth-titan":
    "Титан — сигнатурное существо стихии земли. Гигантский удар по всей шеренге врага.",
};
